import { render, staticRenderFns } from "./SiteIncidentDetail.vue?vue&type=template&id=2d8e8cf8&scoped=true&"
import script from "./SiteIncidentDetail.vue?vue&type=script&lang=js&"
export * from "./SiteIncidentDetail.vue?vue&type=script&lang=js&"
import style0 from "./SiteIncidentDetail.vue?vue&type=style&index=0&id=2d8e8cf8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8e8cf8",
  null
  
)

export default component.exports